// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldIcon } from "@insite/mobius/FormField";
import ArrowLeft from "@mcmc/XDL/Icons/ArrowLeft";
import Search from "@mcmc/XDL/Icons/Search";
import React from "react";
import { css } from "styled-components";

const DropdownIcons: React.FC = () => {
    return (
        <>
            <FormFieldIcon
                className="search-icon"
                src={Search}
                color="primary"
                css={css`
                    left: 2px;
                    right: auto;
                `}
                size={16}
            />
            <FormFieldIcon className="chevron-icon" src={ArrowLeft} color="secondary" size={10} />
        </>
    );
};

export default DropdownIcons;
